import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout';
import ParentView from '@/layout/parentView';
import { getToken } from '@/utils/auth';
import useUserStore from '@/store/user';
import usePermissionStore from '@/store/permission';
import pinia from '@/plugins/pinia';

Vue.use(Router);

/**
 * 路由数据
 *
 * permission 权限值，不传表示所有权限
 * component 组件路径，嵌套路由用'ParentView'包裹
 * activeMenu 菜单激活项，指向path
 * title 页面标题
 */

// 公共路由，不需要登录和鉴权
export const globalRoutes = [
  {
    path: '/login',
    name: 'Login',
    meta: { title: '登录' },
    component: () => import(/* webpackChunkName: "login" */ '@/views/login'),
  },
];

// 主路由，基于用户权限动态去加载
export const mainRoutes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/index',
        name: 'home',
        permission: [1],
        meta: { title: '首页' },
        component: () => import(/* webpackChunkName: "homes" */ '@/views/home'),
      },
      {
        path: '/support',
        name: 'support',
        permission: [6],
        meta: { title: '平台支撑' },
        component: ParentView,
        children: [
          {
            path: '/support/doc',
            name: 'docSupport',
            permission: [63],
            meta: { title: '支撑文档' },
            component: () => import('@/views/support/doc'),
          },
          // {
          //   path: '/support/app',
          //   name: 'appSupport',
          //   permission: [],
          //   meta: { title: '应用升级' },
          //   component: () => import('@/views/support/appUpdate'),
          // },
          // {
          //   path: '/support/agreement',
          //   name: 'agreementSupport',
          //   permission: [],
          //   meta: { title: '协议管理' },
          //   component: () => import('@/views/support/agreement'),
          // },
          {
            path: '/support/speed',
            name: 'speedSupport',
            permission: [64],
            meta: { title: '超速设置' },
            component: () => import('@/views/support/speed'),
          },
          {
            path: '/support/onlineService',
            name: 'onlineService',
            permission: [65],
            meta: { title: '在线客服' },
            component: () => import('@/views/support/onlineService'),
          },
        ],
      },
      {
        path: '/setting',
        name: 'setting',
        permission: [7],
        meta: { title: '系统设置' },
        component: ParentView,
        children: [
          {
            path: '/setting/user',
            name: 'userSetting',
            permission: [71],
            meta: { title: '账号管理' },
            component: () =>
              import(/* webpackChunkName: "setting" */ '@/views/setting/user'),
          },
          {
            path: '/setting/role',
            name: 'roleSetting',
            permission: [72],
            meta: { title: '权限管理' },
            component: () =>
              import(/* webpackChunkName: "setting" */ '@/views/setting/role'),
          },
          {
            path: '/setting/auth',
            name: 'authSetting',
            permission: [81],
            meta: { title: '数据权限' },
            component: () =>
              import(/* webpackChunkName: "setting" */ '@/views/setting/auth'),
          },
        ],
      },
      {
        path: '/assetManagement',
        name: 'assetManagement',
        permission: [2],
        meta: { title: '资产管理' },
        component: ParentView,
        children: [
          {
            path: '/assetManagement/vehicle',
            name: 'vehicle',
            permission: [21],
            meta: { title: '车辆档案' },
            component: () =>
              import(
                /* webpackChunkName: "setting" */ '@/views/vehicleArchives'
              ),
          },
          {
            path: '/assetManagement/device',
            name: 'device',
            permission: [22],
            meta: { title: '设备管理' },
            component: () =>
              import(/* webpackChunkName: "setting" */ '@/views/deviceManage'),
          },
          {
            path: '/assetManagement/charge',
            name: 'charge',
            permission: [23],
            meta: { title: '充电桩管理' },
            component: () =>
              import(/* webpackChunkName: "setting" */ '@/views/chargeManage'),
          },
        ],
      },
      {
        path: '/vehicleUsingUnit',
        name: 'vehicleUsingUnit',
        permission: [3],
        meta: { title: '用车单位' },
        component: ParentView,
        children: [
          {
            path: '/vehicleUsingUnit/unitmanage',
            name: 'unitmanage',
            permission: [31],
            meta: { title: '单位管理' },
            component: () =>
              import(
                /* webpackChunkName: "setting" */ '@/views/vehicleUsingUnit/unitManage'
              ),
          },
          {
            path: '/assetManagement/registeredUsers',
            name: 'registeredUsers',
            permission: [32],
            meta: { title: '注册用户' },
            component: () =>
              import(
                /* webpackChunkName: "setting" */ '@/views/vehicleUsingUnit/registeredUsers'
              ),
          },
          {
            path: '/assetManagement/process',
            name: 'process',
            permission: [33],
            meta: { title: '加入审核' },
            component: () =>
              import(
                /* webpackChunkName: "setting" */ '@/views/vehicleUsingUnit/process'
              ),
          },
        ],
      },
    

      {
        path: '/rental',
        name: 'rental',
        permission: [4],
        meta: { title: '出租管理' },
        component: ParentView,
        children: [
          {
            path: '/rental/bill',
            name: 'billRental',
            permission: [41],
            meta: { title: '租车结算' },
            component: () =>
              import(
                /* webpackChunkName: "rental" */ '@/views/rental/bill'
              ),
          },
          {
            path: '/rental/order',
            name: 'orderRental',
            permission: [42],
            meta: { title: '租车订单' },
            component: () =>
              import(
                /* webpackChunkName: "rental" */ '@/views/rental/order'
              ),
          },
          {
            path: '/rental/valuation',
            name: 'valuationRental',
            permission: [43],
            meta: { title: '计价管理' },
            component: () =>
              import(
                /* webpackChunkName: "rental" */ '@/views/rental/valuation'
              ),
          },
          {
            path: '/rental/repay',
            name: 'repayRental',
            permission: [44],
            meta: { title: '还车点管理' },
            component: () =>
              import(
                /* webpackChunkName: "rental" */ '@/views/rental/repay'
              ),
          },
        ],
      },

      {
        path: '/operate',
        name: 'operate',
        permission: [5],
        meta: { title: '运营管理' },
        component: ParentView,
        children: [
          {
            path: '/operate/vehicleReview',
            name: 'vehicleReview',
            permission: [53],
            meta: { title: '验车审核' },
            component: () =>
              import(/* webpackChunkName: "setting" */ '@/views/vehicleReview'),
          },
          {
            path: '/operate/accident',
            name: 'accident',
            permission: [54],
            meta: { title: '事故处理' },
            component: () =>
              import(/* webpackChunkName: "setting" */ '@/views/accident'),
          },
          {
            path: '/operate/screen',
            name: 'screenOperate',
            permission: [51],
            meta: { title: '数据大屏' },
            component: () => import(/* webpackChunkName: "screen" */ '@/views/screen'),
          },
          {
            path: '/operate/moving',
            name: 'moving',
            permission: [55],
            meta: { title: '挪车记录' },
            component: () =>
              import(
                /* webpackChunkName: "operate" */ '@/views/operationManage/moving'
              ),
          },
          {
            path: '/operate/alarm',
            name: 'alarm',
            permission: [52],
            meta: { title: '实时告警' },
            component: () =>
              import(
                /* webpackChunkName: "operate" */ '@/views/operationManage/alarm'
              ),
          },
          {
            path: '/operate/maintain',
            name: 'maintain',
            permission: [56],
            meta: { title: '维修记录' },
            component: () =>
              import(
                /* webpackChunkName: "operate" */ '@/views/operationManage/maintain'
              ),
          },
          {
            path: '/operate/track',
            name: 'track',
            permission: [58],
            meta: { title: '数据处理' },
            component: () =>
              import(
                /* webpackChunkName: "operate" */ '@/views/track'
              ),
          },
        ],
      },
      {
        path: '/403',
        name: '403',
        meta: { title: '无权限' },
        component: () => import(/* webpackChunkName: "403" */ '@/views/403'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    meta: { title: '网页丢失了' },
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
  },
];

const router = new Router({
  mode: 'history',
  routes: globalRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
let routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err);
};
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err);
};

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置标题
  if (to.title) {
    document.title = to.title;
  }
  // 权限控制
  const permissionStore = usePermissionStore(pinia);
  const token = getToken();
  if (token) {
    // 有token表示已登录
    const userStore = useUserStore(pinia);
    const userInfo = userStore.userInfo || {};
    if (userInfo.userId) {
      // 有用户信息，进入路由
      next();
    } else {
      // 没有userId，去获取用户信息
      userStore.getUserInfo().then(() => {
        permissionStore.generateRoutes().then(accessRoutes => {
          // 添加动态路由
          accessRoutes.forEach(route => {
            router.addRoute(route);
          });
          next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
        });
      });
    }
  } else {
    next();
    // 未登录
    const whiteList = permissionStore.getWhiteList();
    if (whiteList.includes(to.path)) {
      // 在免登录白名单内，进入路由
      next();
    } else {
      // 否则全部重定向到登录页
      next(`/login?redirect=${to.fullPath}`);
    }
  }
});

export default router;
